import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApi } from '@/composables/useApi'

export const useMenuConfigStore = defineStore('menuConfig', () => {
  const disabledPages = ref([])
  const loaded = ref(false)

  const load = async () => {
    const api = useApi()
    const result = await api.get('/api/congregation/menu-config')
    disabledPages.value = result.disabledPages || []
    loaded.value = true
  }

  // Antes de cargar, no se oculta nada (evita el parpadeo de "menú vacío").
  const isEnabled = (key) => !loaded.value || !disabledPages.value.includes(key)

  const reset = () => {
    disabledPages.value = []
    loaded.value = false
  }

  return { disabledPages, loaded, load, isEnabled, reset }
})
